import { useQuery } from 'hooks/useCustomQuery';
import getAvailableServiceProfiles from 'API/ServiceProfiles/getAvailableServiceProfiles';

/** (3155) The service profiles the company could add on Add Services. */
const useGetAvailableServiceProfiles = (companyId, options = {}) =>
    useQuery({
        queryKey: ['setupProgress', 'availableServiceProfiles', companyId],
        queryFn: async () =>
            (await getAvailableServiceProfiles(companyId)) || [],
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetAvailableServiceProfiles;
